export const FIREWALL_DEFAULT_RULE = 'allow'

export const FIREWALL_RULE_OPTIONS = [
  { value: 'allow', text: 'Allow' },
  { value: 'deny', text: 'Deny' },
]

export const EXPIRE_DATE_FORMAT = 'DD.MM.YYYY HH:mm:ss'
